import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-broadcasting-gallery-add-image-dialog',
  templateUrl: './broadcasting-gallery-add-image-dialog.component.html',
  styleUrls: ['./broadcasting-gallery-add-image-dialog.component.scss']
})
export class BroadcastingGalleryAddImageDialogComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  base64: string;
  url: string;

  constructor(public dialogRef: MatDialogRef<BroadcastingGalleryAddImageDialogComponent>,
    private validationImageService: ValidationImageService) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit() { }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        this.base64 = base64;
      },
      (error) => {
      }
    );
  }

  public accept() {
    if (this.validateForm()) {
      if (this.base64 && !this.url) {
        this.dialogRef.close({ type: 'image', file: this.base64, url: null, info: 60 });
      } else if (!this.base64 && this.url) {
        this.dialogRef.close({ type: 'image', file: null, url: this.url, thumbnail_url: null, info: 60 });
      }
    } else {
      return false;
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

  public validateForm() {
    if (this.base64 && !this.url) {
      return true;
    } else if (!this.base64 && this.url) {
      return true;
    }
    return false;
  }

}
